export default __webpack_public_path__ + "static/media/ipro.1406a988.svg";